/**
 *
 * Asynchronously loads the component for GoalFor
 *
 */

import { lazyLoad } from 'utils/loadable';

export const GoalFor = lazyLoad(
  () => import('./index'),
  module => module.GoalFor,
);
